import apiClient from "./apiClient";

export const fetchFuelPrices = async () => {
    const response = await apiClient.get("/api/fuel_prices/all");
    return response.data;
};

export const syncFuelPrices = async () => {
    const response = await apiClient.post("/api/fuel_prices/sync");
    return response.data;
};
